import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getAlarmsVendors } from '@api/alarmManagement';

import { optionsFormatted } from '@utils/formatter';

import { TNameTitle } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles, TVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { VENDORS_ALARMS } from '@constants/queryKeys';

interface IUseQueryAlarmVendorsReturn {
	alarmVendors: TNameTitle<TVendorsValues>[];
	isLoadingAlarmVendors: boolean;
	alarmVendorsOptions: TSelectOption<TVendorsValues>[];
}

export function useQueryAlarmVendors(): IUseQueryAlarmVendorsReturn {
	const {
		accessPermission: {
			networkOperatorAlarmManager,
		},
	} = useAppSelector(auth);

	const {
		data: vendors,
		isFetching,
	} = useQuery({
		queryKey: [VENDORS_ALARMS],
		queryFn: getAlarmsVendors,
		enabled: [networkOperatorAlarmManager],
		allowedRoles: [EUserRoles.networkOperatorAlarmManager],
		...refetchOptions,
	});

	const alarmVendorsOptions = vendors ? optionsFormatted(vendors) : [];

	return {
		alarmVendors: vendors || [],
		isLoadingAlarmVendors: isFetching,
		alarmVendorsOptions: alarmVendorsOptions as TSelectOption<TVendorsValues>[],
	};
}
